import {useFormik} from 'formik'
import {KTIcon} from '../../../../../_metronic/helpers'
import {
  initNotificationConfigureFormValues,
  INotificationConfigAPI,
  INotificationConfigureFormValues,
} from '../../_model'
import MultiSelectNumber from '../../../../utils/components/MultiSelectNumber'
import {useRittApp} from '../../../../utils/contextProvider/RittAppProvider'
import {ISelectOption} from '../../../../utils/core/_model'
import {BASE_URL} from '../../../config'
import toast from 'react-hot-toast'
import axios from 'axios'
import {useAuth} from '../../../auth'
import {getMsisdn} from '../../../analyze/_helper-functions'
import {useEffect, useState} from 'react'
import MultiSelectWithDefault from '../MultiSelectWithDefault'

const NOTIFICATION_SUB_CONFIG = `${BASE_URL}/api/protect/notificationSubscriptionSetup`
const GET_NITIFICATION_SETUP_DETAILS = `${BASE_URL}/api/protect/getNotificationSubscriptionSetupDetails`

type Props = {
  isLow: boolean
  isLoading: boolean
  notificationConfigureValues: INotificationConfigureFormValues
}

const LowBalance = ({isLow, isLoading, notificationConfigureValues}: Props) => {
  const {auth} = useAuth()
  const {emailOptions} = useRittApp()

  const formik = useFormik({
    initialValues: notificationConfigureValues,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        let data: Partial<INotificationConfigureFormValues> = {}
        if (isLow) {
          const {exportuseremail, notify_num, ...sendData} = values
          data = {...sendData, notify_msisdn: getMsisdn(notify_num)}
        } else {
          const {exportuseremail, repeat_days, low_balance_amount, notify_num, ...sendData} = values

          data = {
            ...sendData,
            notify_msisdn: getMsisdn(notify_num),
          }
        }

        const response = await axios.post(NOTIFICATION_SUB_CONFIG, data, {
          headers: {
            Authorization: `Bearer ${auth?.accessToken}`,
          },
          params: {
            isLow: isLow ? '1' : '0',
          },
        })

        if (response.status === 202) {
          toast.dismiss()
          toast.success(response.data.message)
        }

        console.log(response)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const onSelectEmails = (selected: ISelectOption[]) => {
    const emails = selected.map((email) => email.value)
    formik.setFieldValue('notify_email', emails)
  }

  const onSelectEmailsCC = (selected: ISelectOption[]) => {
    const emails = selected.map((email) => email.value)
    formik.setFieldValue('notify_email_cc', emails)
  }

  const onSelectEmailsBCC = (selected: ISelectOption[]) => {
    const emails = selected.map((email) => email.value)
    formik.setFieldValue('notify_email_bcc', emails)
  }

  const setMsisdn = (numbers: string[]) => {
    if (!numbers) return []
    return numbers.map((num) => ({value: num, label: num}))
  }

  // const getSetupDetails = async () => {
  //   try {
  //     setIsLoading(true)
  //     toast.loading('Processing..')
  //     const response = await axios.get<INotificationConfigAPI>(GET_NITIFICATION_SETUP_DETAILS, {
  //       headers: {
  //         Authorization: `Bearer ${auth?.accessToken}`,
  //       },
  //       params: {
  //         isLow: isLow ? '1' : '0',
  //       },
  //     })

  //     console.log(response)

  //     if (response.status === 200) {
  //       toast.dismiss()
  //       toast.success('Success')
  //       const data = response.data
  //       console.log(data)
  //       console.log(data.notify_email_cc)
  //       formik.setValues({
  //         notify_num: setMsisdn(data.notify_msisdn) || [],
  //         notify_msisdn: data.notify_msisdn || [],
  //         exportuseremail: data.notify_email || [],
  //         notify_email: data.notify_email || [],
  //         notify_email_cc: data.notify_email_cc || [],
  //         notify_email_bcc: data.notify_email_bcc || [],
  //         repeat_days: data.repeat_days || 0,
  //         low_balance_amount: data.low_balance_amount || 0,
  //       })

  //       setIsLoading(false)
  //     }
  //   } catch (error) {
  //     console.log(error)
  //     setIsLoading(false)
  //   }
  // }

  useEffect(() => {
    formik.setValues({
      notify_num: notificationConfigureValues.notify_num,
      notify_msisdn: notificationConfigureValues.notify_msisdn,
      exportuseremail: notificationConfigureValues.exportuseremail,
      notify_email: notificationConfigureValues.notify_email,
      notify_email_cc: notificationConfigureValues.notify_email_cc,
      notify_email_bcc: notificationConfigureValues.notify_email_bcc,
      repeat_days: notificationConfigureValues.repeat_days,
      low_balance_amount: notificationConfigureValues.low_balance_amount,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationConfigureValues])

  // useEffect(() => {
  //   getSetupDetails()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isLow])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Low Account Balance</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            {isLoading ? (
              <div className='text-center'>
                <div className='spinner-border' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </div>
              </div>
            ) : (
              <form onSubmit={formik.handleSubmit}>
                <div className='row row-cols-1 row-cols-sm-2'>
                  <div className='col'>
                    <div className='fv-row mb-7'>
                      <label className='fw-semibold fs-6 mb-2'>Number for SMS</label>

                      <MultiSelectNumber
                        selectedOptions={formik.values.notify_num}
                        formik={formik}
                        fieldname='notify_num'
                      />
                    </div>
                  </div>

                  <div className='col'>
                    <div className='fv-row mb-7'>
                      <label className='fw-semibold fs-6 mb-2'>Email</label>

                      <MultiSelectWithDefault
                        options={emailOptions}
                        formik={formik}
                        onSelect={onSelectEmails}
                        fieldname='notify_email'
                      />
                    </div>
                  </div>

                  <div className='col'>
                    <div className='fv-row mb-7'>
                      <label className='fw-semibold fs-6 mb-2'>Email CC</label>

                      <MultiSelectWithDefault
                        options={emailOptions}
                        formik={formik}
                        onSelect={onSelectEmailsCC}
                        fieldname='notify_email_cc'
                      />
                    </div>
                  </div>

                  <div className='col'>
                    <div className='fv-row mb-7'>
                      <label className='fw-semibold fs-6 mb-2'>Email BCC</label>

                      <MultiSelectWithDefault
                        options={emailOptions}
                        formik={formik}
                        onSelect={onSelectEmailsBCC}
                        fieldname='notify_email_bcc'
                      />
                    </div>
                  </div>

                  {isLow && (
                    <>
                      <div className='col'>
                        <div className='fv-row mb-7'>
                          <label className='fw-semibold fs-6 mb-2'>Repeat every</label>

                          <input
                            {...formik.getFieldProps('repeat_days')}
                            placeholder='1'
                            type='number'
                            className='form-control form-control custom-input mb-3 mb-lg-0'
                            autoComplete='off'
                          />
                          <p className='fs-5 fw-semibold m-2'>Days</p>
                        </div>
                      </div>

                      <div className='col'>
                        <div className='fv-row mb-7'>
                          <label className='fw-semibold fs-6 mb-2'>
                            Notify me if balance below
                          </label>

                          <input
                            {...formik.getFieldProps('low_balance_amount')}
                            placeholder='500'
                            type='number'
                            className='form-control form-control custom-input mb-3 mb-lg-0'
                            autoComplete='off'
                          />
                          <p className='fs-5 fw-semibold m-2'>BDT</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className='text-center pt-15'>
                  <button
                    type='reset'
                    className='btn btn-light me-3 border border-gray-600'
                    data-kt-users-modal-action='cancel'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    CLOSE
                  </button>

                  <button
                    type='submit'
                    className='btn btn-primary me-3'
                    data-kt-users-modal-action='cancel'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LowBalance
